import { configureStore } from "@reduxjs/toolkit";
import gameSlice from "./store/slices/slice.Game";
import appSlice from "./store/slices/slide.App";
 
export const store = configureStore({
  reducer: {
    game: gameSlice, 
    app: appSlice,
  },
});